import BaseState from '@state/BaseState'
import { Signals } from "@/Imports";
import GameStatesEnum from "../GameStatesEnum";
import UIBehaviors from "@/managers/ui/UIBehaviors";

export default class GetSpinResponseState extends BaseState {

  begin() {
    Signals.spinResponse.addOnce(this.onSpinResponse, this)
    Signals.cancelSpin.addOnce(this.onCancelSpin, this)
    Signals.gameMessage.dispatch ('spin')
  }

  onCancelSpin() {
    this.stateMachine.setState(GameStatesEnum.SPIN_STOP)
  }

  onSpinResponse = (data) => {
    this.model.spinRawData = data
    // let timeout = Math.max(0, UIBehaviors.getEnableUIDelay())
    // setTimeout( () => this.end(), timeout)
    this.end()
  }

  end = () => {
    this.stateMachine.setState(GameStatesEnum.SPIN_STOP)
  }

  cleanUp() {
    Signals.spinResponse.remove(this.onSpinResponse, this)
    Signals.cancelSpin.remove(this.onCancelSpin, this)
  }
}
